import { Button } from "components/button"
import React from "react"
import { useSideNav } from "hooks/useSideNav"
import "./menu.module.scss"
import HamburgerIcon from "./HamburgerIcon"

interface MenuButtonProps {
  isHidden?: boolean
}

const MenuButton = ({ isHidden = false }: MenuButtonProps) => {
  const { handleOpenNav, isNavOpen, isClosing } = useSideNav()

  const hiddenClassName = isHidden ? "menu-button--hidden" : ""

  return (
    <>
      <Button
        variant="flashy-icon"
        onClick={handleOpenNav}
        extraClassNames={`menu-button ${isNavOpen === true ? "open" : ""} ${
          isClosing === true ? "close" : ""
        } ${hiddenClassName}`}
        aria-label="open side menu"
        // activeClassName="open"
        disabled={isHidden}
      >
        <HamburgerIcon />
      </Button>
    </>
  )
}

export default MenuButton
